import { render } from "./Tostadas.vue?vue&type=template&id=41ad9123"
import script from "./Tostadas.vue?vue&type=script&lang=js"
export * from "./Tostadas.vue?vue&type=script&lang=js"
script.render = render

export default script